import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { Box, Typography, Grid, Card, CardMedia, CardContent,Stack, Container, Paper, TextField, Button, Checkbox, Fade, Slide, List, ListItem} from '@mui/material';
import { LocationOn, Mountain, Business, TrendingUp } from '@mui/icons-material';
import { Formik, Form, Field, useFormik } from 'formik';
import * as Yup from 'yup';
import TourIcon from '@mui/icons-material/Tour';
import BusinessIcon from '@mui/icons-material/Business';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FormField from '../../components/form/formField';
import leadService from '../../services/interestingLeads';
import { useSnackbar } from 'notistack';

export default function IgatpuriLaunch(){
    window.heap.track('How it works', {
        buttonName: 'How it works', 
        category: 'Page view',
      });


  

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    
    const timer = setTimeout(() => {
      setModalOpen(true);
    }, 10000); // 10 seconds delay

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  const handleCloseModal = () => {
    setModalOpen(false);
  };
    return(
      <>
        <HeroSection />
        <WhyRealX />
        <AboutRealXWithForm />
        <ContactModal open={modalOpen} onClose={handleCloseModal} />
      </>
        

    )
}


const HeroSection = () =>{
    const [currentLanguage, setCurrentLanguage] = useState(0);
    const navigate = useNavigate();

  const translations = [
    { text: 'Igatpuri', lang: 'English' },
    { text: 'इगतपुरी', lang: 'Hindi' },
  ];

  const images = [
    "assets/images/igatpuri/igat1.jpeg",
    "assets/images/igatpuri/igat2.jpeg",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentLanguage((prev) => (prev + 1) % translations.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Apply overflow: visible to the slick-list element after component mounts
    const slickList = document.querySelector('.slick-list');
    if (slickList) {
      slickList.style.overflow = 'visible';
    }
  }, []);

    useEffect(() => {
      const slickList = document.querySelector('.slick-list');
      if (slickList) {
        slickList.style.height = '500px';
      }
    }, []);
  

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    adaptiveHeight: true, // Adjust height based on content 
  };

  const navigateToProperty =()=>{
    console.log("cjccjcj ");
    
    navigate('https://platform.realx.in/dashboard/property/654d1fc6b69643faa6deb9df')
  }
    return(
        <Box sx={{ minHeight: '100vh', backgroundColor: 'black', display: 'flex', alignItems: 'center',justifyContent:'center'}} >
      <Grid container sx={{ mt:{md:'85px',xs:'50px'},padding: {xl:30,lg:15,md:8,xs:4},}} rowGap={3} columnGap={3}>
        <Grid item xs={12} md={5.8} sx={{height:'100%',alignItems:'center',justifyContent:'center',order: { xs: 2, md: 1 } }}>
          <Stack direction={'column'} sx={{height:'100%',justifyContent:'center',px:{md:2,xs:0}}}>
          <Box sx={{ position: 'relative', height: 125, marginBottom: {lg:2,md:1,xs:0} }}>
            {translations.map((translation, index) => (
              <Typography
                key={translation.lang}
                variant="h1"
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  fontSize: { xs: '3.5rem', sm: '4.5rem', md: '5rem' },
                  fontWeight: 'bold',
                  color: 'red',
                  opacity: currentLanguage === index ? 1 : 0,
                  transform: currentLanguage === index ? 'translateY(0)' : 'translateY(100%)',
                  transition: 'all 1s ease-in-out',
                  textAlign:{xs:'center',md:'left'}
                }}
              >
                {translation.text}
              </Typography>
            ))}
          </Box>
          <Typography variant="h3" sx={{ fontWeight: 'bold', color: 'white', marginBottom: 2, textAlign:{xs:'center',md:'left'}}}>
            A Scenic Haven for Strategic Investors
          </Typography>
          <Typography sx={{ color: 'white', textAlign:{xs:'center',md:'left'}}}>
            RealX is pleased to introduce a new investment opportunity in the serene hills of Igatpuri,
            offering you the chance to become a direct co-owner of picturesque land in this tranquil retreat.
          </Typography>
            <Stack mt={4} direction="row" justifyContent={{md:"start",xs:"center"}}>
                <Button
                  variant="contained"
                  sx={{ py: '12px !important' }}
                  href="https://platform.realx.in/dashboard/property/66e02f2f9acaf02fc62a4357"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ fontSize: '28px', fontWeight: 600 }}>
                      Explore The Opportunity
                    </Typography>
                    <ArrowForwardIcon />
                  </Stack>
                </Button>

            </Stack>
        </Stack>

        </Grid>

        <Grid item xs={12} md={5.8} sx={{order: { xs: 1, md: 2 }}} >
            <Box sx={{ position: 'relative',overflow: 'hidden'   }}>
              <Slider {...sliderSettings} >
                {images.map((image, index) => (
                  <div key={index} style={{ height: '100%', overflow: 'hidden' ,borderRadius:2}}>
                     <Box sx={{width:"100%", objectFit: 'cover', height: {md:'450px',xs:'200px'},borderRadius:'8px'}} component={"img"} src={image}></Box>
                  </div>
                ))}
              </Slider>
            </Box>
        </Grid>
      </Grid>
    </Box>
  )
};

const WhyRealX = ()=>{

  const features = [
    {
      icon: <LocationOn fontSize="large" />,
      title: "Strategic Location",
      description: [
        "120 km from Mumbai | 45 km from Nashik",
        "Under 2 hours from Mumbai via Samruddhi Expressway (inauguration - late 2025)"
      ],
      bgcolor1:"#e4122f1a",
      color1:"red" 
    },
    {
      icon: <TourIcon fontSize="large" />,
      title: "Tourism & Lifestyle Hub",
      description: ["Surrounded by Bhatsa Dam, Kalsubai Peak & Vipassana Centre", "High demand for second homes & eco-resorts"],
      bgcolor1:"#9ddb8740",
      color1:"#37c703" 
    },
    {
      icon: <BusinessIcon fontSize="large" />,
      title: "Future-Ready Infrastructure",
      description: ["Samruddhi Mahamarg | Mumbai-Nashik Highway widening", "Igatpuri-Vadhavan Port Expressway in pipeline", "Proximity to 2027 Kumbh Mela site (40-60 Cr expected visitors in Nashik)"],
      bgcolor1:"#fbd80033",
      color1:"#fbd800" 
    },  
    {
      icon: <TrendingUpIcon fontSize="large" />,
      title: "Impressive Growth",
      description: ["Consistent CAGR of ~19.5% over the past 3 years, demonstrating strong market performance and potential for future returns"],
      bgcolor1:"#1200ff0d",
      color1:"blue" 
    }
  ];


  return(
    <section id="why-now" style={{ padding: '80px 0', backgroundColor: '#ffffff' }}>
    <Box sx={{ maxWidth: '1200px', margin: '0 auto', px: 2 }}>
      <Stack alignItems="center" sx={{ mb: 6 }}>
        <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2 }}>WHY NOW?</Typography>
        <Box sx={{ width: '80px', height: '4px', backgroundColor: '#f44336', margin: '0 auto' }}></Box>
      </Stack>

      {/* Grid Layout for Cards */}
      <Grid container spacing={4}>
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} md={6} key={index}>
            <Box
              sx={{
                height: '100%',
                opacity: 1,
                transition: 'opacity 0.5s ease-out',
                animationDelay: `${index * 200}ms`,
              }}
            >
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  border: '2px solid rgb(235, 204, 204)',
                  transition: 'transform 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    borderColor: '#f44336',
                  },
                  boxShadow:0.5
                }}
              >
                <Stack direction={'column'} sx={{padding: "16px"}} rowGap={{md:3,xs:2}} alignItems={{xs:'center',md:'start'}}> 
                  <Stack direction={{md:'row',xs:'column'}} alignItems={'center'} columnGap={2} rowGap={2}>
                    <CardMedia
                      sx={{
                        padding: 0.5,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '8px',
                        height: 40,
                        width: 40,
                        mt: 0.5,
                        ml: 0.5,
                        bgcolor: feature.bgcolor1,
                        color: feature.color1,
                        // Centering the content for mobile screens only
                        justifyContent: { xs: 'center', md: 'flex-start' }, // On xs screens, center it, on md and larger align to flex-start
                        alignItems: { xs: 'center', md: 'flex-start' }, // Similarly for aligning items
                      }}
                    >
                      {feature.icon}
                    </CardMedia>
                    <Typography variant="body1" sx={{ fontWeight: 600,textAlign: { xs: 'center', md: 'left' } }}>
                      {feature.title}
                    </Typography>
                  </Stack>
                  <Stack sx={{  display: "flex",}}>
                      <List sx={{ listStyleType: 'disc', pl: 2 , pt:0,width: "100%",}}>
                        {feature.description.map((line, index) => (
                          <ListItem key={index} sx={{ display: 'list-item', padding: "0px 0px 8px 0px!important"}}>
                            <Typography variant="body1" component="span">
                              {line}
                            </Typography>
                          </ListItem>
                        ))}
                      </List>
                  </Stack>
                </Stack>
              </Card>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  </section>

  )
}

const AboutRealXWithForm=()=>{
  const { enqueueSnackbar } = useSnackbar();
  const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    mobileNumber: Yup.string()
      .matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits')
      .required('Phone number is required'),
    email: Yup.string().email('Invalid email format').notRequired()
  });

  const initialValues = {
    name: '',
    mobileNumber: '',
    email: '',
    pingMe: true
  };

  const handleSubmit = async(values) => {
    const formData = {
      ...values,
      listingId: "66e02f2f9acaf02fc62a4357",
      propertyCode: "2024000437"
    };
    
    const res = await leadService.registerLeads(formData);

    if(res && res.success){
      enqueueSnackbar("Registration Successful", { variant: "success", autoHideDuration: 2000 })
    }
    else{
      enqueueSnackbar("Something went wrong", { variant: "error", autoHideDuration: 2000 });
    }
  };

  const navigate = useNavigate();

  return(
    <section id="about" style={{ padding: '50px 0', backgroundColor: '#000000', color: '#ffffff' }}>
      <Container>
        <Grid container alignItems={'center'} justifyContent={'center'} columnGap={0} rowGap={3}>
          {/* Left Section */}
          <Grid item xs={12} md={6}>
            <Box sx={{pr:4}}>
              <Stack alignItems={{md:"start",xs:"center"}} sx={{ mb: 3 }}>
                <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2 }}>ABOUT REALX</Typography>
                <Box sx={{ width: '80px', height: '4px', backgroundColor: '#f44336', margin: { xs: '0 auto', md: '0' }}}></Box>
              </Stack>
              <Stack>
              <Typography variant="landingSubText" sx={{ fontWeight:600, mb: 3 ,textAlign:{xs:'center',md:'left'}}}>
                Co-own Land. Build Wealth. The Smarter Way.
              </Typography>
              <Stack sx={{ color: '#e0e0e0' ,rowGap:2}}>
                <Typography variant="body1"  sx={{textAlign:{xs:'center',md:'left'}}}>
                  RealX makes investing in land easy, transparent, and affordable.
                </Typography>
                <Typography variant="body1" sx={{textAlign:{xs:'center',md:'left'}}}>
                  We offer fractional ownership in premium land parcels so that you can start building a strong real estate portfolio without the hassle of buying entire plots.
                </Typography>
                <Typography variant="body1" sx={{textAlign:{xs:'center',md:'left'}}}>
                  Enjoy seamless digital ownership, zero regular maintenance payment worries, and complete access to verified property details, right from your screen.
                </Typography>
                <Typography variant="body1" sx={{textAlign:{xs:'center',md:'left'}}}>
                  Just real, tangible assets with long-term growth potential.
                </Typography>
              </Stack>
              </Stack>
              
            </Box>
          </Grid>

          {/* Right Section: Form */}
          <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Paper sx={{ backgroundColor: '#212121', p: 4, borderRadius: 2, boxShadow: 3 }}>
              <Stack rowGap={3} justifyContent={'center'} alignItems={'center'}>
                <Typography variant='h4' sx={{color: '#f44336', textAlign: 'center' }}>Join hundreds of investors rethinking land investment.</Typography>
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ values, handleChange, handleBlur,getFieldProps, touched, errors }) => (
                    <Form>
                      <Stack rowGap={3}>
                        <FormField
                          label={"Name*"}
                          inputProps={{
                            ...getFieldProps("name"),
                            error: Boolean(touched.name && errors.name),
                            helperText: touched.name && errors.name
                          }}
                        />
                        <FormField
                          label={"Phone Number*"}
                          inputProps={{
                            ...getFieldProps("mobileNumber"),
                            error: Boolean(touched.phone && errors.phone),
                            helperText: touched.phone && errors.phone
                          }}
                        />
                        <FormField
                          label={"Email"}
                          inputProps={{
                            ...getFieldProps("email"),
                            error: Boolean(touched.email && errors.email),
                            helperText: touched.email && errors.email
                          }}
                        />
                        <Stack>
                          <Stack direction={'row'} alignItems={"center"} rowGap={1}>
                            <Checkbox
                              name="pingMe"
                              checked={values.pingMe}
                              onChange={handleChange}
                              color="primary"
                              sx={{
                                // transform: 'scale(1.3)', // Scales the checkbox to 1.5 times its original size
                                '& .MuiSvgIcon-root': {
                                  fontSize: 35, // Sets the font size of the SVG icon
                                },
                              }}

                            />
                            <Typography variant="body3" sx={{ color: "#FFF", fontWeight: 500 }}>Ping me on WhatsApp</Typography>
                          </Stack>
                          <Typography variant="body3" color="#1bff00">
                            * We promise not to spam.
                          </Typography>
                        </Stack>
                        <Stack sx={{ width: '100%', alignItems: 'center' }}>
                          <Button variant="contained" type="submit" sx={{ width: '80%', py: '12px !important' }}>
                            <Typography onClick={handleSubmit} sx={{ fontSize: '28px', fontWeight: 600 }}>Submit</Typography>
                          </Button>
                        </Stack>
                        <Typography variant="body3" color="textSecondary">
                          We don't share your data with anyone.{' '}
                          <a  href="https://www.realx.in/policy" target="_blank"  style={{ color: '#f44336' ,cursor:'pointer' }}>
                            Here is our privacy policy
                          </a>
                        </Typography>
                      </Stack>
                    </Form>
                  )}
                </Formik>
              </Stack>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </section>

  )
}



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Fade direction="up" ref={ref} {...props} />;
});


const ContactModal = ({ open, onClose }) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    mobileNumber: Yup.string()
      .matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits')
      .required('Phone number is required'),
    email: Yup.string().email('Invalid email format').notRequired()
  });

  const initialValues = {
    name: '',
    mobileNumber: '',
    email: '',
    pingMe: true
  };

  const handleSubmit = async(values) => {
    console.log(values);
    // Ensure listingId and propertyCode are included in the submission
    const formData = {
      ...values,
      listingId: "66e02f2f9acaf02fc62a4357",
      propertyCode: "2024000437"
    };
    
    const res = await leadService.registerLeads(formData);

    if(res && res.success){
      enqueueSnackbar("Registration Successful", { variant: "success", autoHideDuration: 3000 });
      onClose();
    }
    else{
      enqueueSnackbar("Something went wrong", { variant: "error", autoHideDuration: 3000 });
    }
  };

  return (
 
    <Dialog open={open}    transitionDuration={1000} // Set the transition duration to 500ms
    keepMounted TransitionComponent={Transition}  onClose={onClose} sx={{maxWidth:'500px', width: '100%',margin: '0 auto'}}>
      <DialogContent>
        <Box sx={{
                  position: "absolute",
                  right: 4,
                  top:2,
                  // padding: 2.5,
                  color: { md: "#000", xs: "text.disabled" }
                }}>
                  <CloseIcon onClick={onClose} sx={{ width: 24, height: 24, cursor: "pointer" }} />
                </Box>
      <Stack rowGap={3}>
      <Typography variant='h4'>Want to know more about the investment opportunity?</Typography>
      <Typography> Get started with <span>Real</span><span style={{color:'red'}}>X</span></Typography>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, handleChange,getFieldProps, handleBlur, touched, errors }) => (
            <Form>
              <Stack rowGap={3}>
                  <FormField
                    label={"Name*"}
                    inputProps={{
                      ...getFieldProps("name"),
                      error: Boolean(touched.name && errors.name),
                      helperText: touched.name && errors.name
                    }}
                  />
                  <FormField
                    label={"Phone Number*"}
                    inputProps={{
                      ...getFieldProps("mobileNumber"),
                      error: Boolean(touched.mobileNumber && errors.mobileNumber),
                      helperText: touched.mobileNumber && errors.mobileNumber
                    }}
                  />
                  <FormField
                    label={"Email (Optional)"}
                    inputProps={{
                      ...getFieldProps("email"),
                      error: Boolean(touched.email && errors.email),
                      helperText: touched.email && errors.email
                    }}
                  />
              
                  <Stack sx={{ width: '100%', alignItems: 'center' }}>
                    <Button variant="contained" type="submit" sx={{ width: '80%', py: '12px !important' }}>
                      <Typography onClick={handleSubmit} sx={{ fontSize: '28px', fontWeight: 600 }}>Submit</Typography>
                    </Button>
                  </Stack>
                <Typography variant="body3" color="textSecondary">
                  We don't share your data with anyone.{' '}
                  <a href="https://www.realx.in/policy" target="_blank" style={{ color: '#f44336' ,cursor:"pointer"}}>
                    Here is our privacy policy
                  </a>
                </Typography>
              </Stack>
            </Form>
          )}
        </Formik>
        </Stack>  
      </DialogContent>
    </Dialog>
  
  );
};


